export const GET_ACTIVE_NOTIFICATIONS_REQUEST = "GET_ACTIVE_NOTIFICATIONS_REQUEST";
export const GET_ACTIVE_NOTIFICATIONS_SUCCESS = "GET_ACTIVE_NOTIFICATIONS_SUCCESS";
export const GET_ACTIVE_NOTIFICATIONS_FAILURE = "GET_ACTIVE_NOTIFICATIONS_FAILURE";

export const CREATE_NOTIFICATION_REQUEST = "CREATE_NOTIFICATION_REQUEST";
export const CREATE_NOTIFICATION_SUCCESS = "CREATE_NOTIFICATION_SUCCESS";
export const CREATE_NOTIFICATION_FAILURE = "CREATE_NOTIFICATION_FAILURE";

export const UPDATE_NOTIFICATION_REQUEST = "UPDATE_NOTIFICATION_REQUEST";
export const UPDATE_NOTIFICATION_FAILURE = "UPDATE_NOTIFICATION_FAILURE";

export const ENABLE_NOTIFICATION_REQUEST = "ENABLE_NOTIFICATION_REQUEST";
export const ENABLE_NOTIFICATION_FAILURE = "ENABLE_NOTIFICATION_FAILURE";

export const DISABLE_NOTIFICATION_REQUEST = "DISABLE_NOTIFICATION_REQUEST";
export const DISABLE_NOTIFICATION_FAILURE = "DISABLE_NOTIFICATION_FAILURE";

export const DELETE_NOTIFICATION_REQUEST = "DELETE_NOTIFICATION_REQUEST";
export const DELETE_NOTIFICATION_FAILURE = "DELETE_NOTIFICATION_FAILURE";